import { Component, inject, Input } from '@angular/core';
import { UntypedFormGroup } from '@angular/forms';
import { UntilDestroy } from '@ngneat/until-destroy';

import { deepClone } from '$utils';
import { ModalWizardModels } from 'src/app/components/modal-wizard/shared/models/modal-wizard.model';
import { PlaceBidForFormComponent } from '../../components/place-bid-for-form/place-bid-for-form.component';
import { BiddingModels } from '../../shared/models/bidding.model';
import { BiddingStoreKey, BiddingStoreService } from '../../store/bidding.store';

@UntilDestroy()
@Component({
  selector: 'app-place-bid-for-step-content',
  template: ` <app-place-bid-for-form (formValidityChanged)="onFormValidityChanged($event)" (formValuesChanged)="onFormValuesChanged($event)" /> `,

  imports: [PlaceBidForFormComponent],
})
export class PlaceBidForStepContentComponent implements ModalWizardModels.StepContent {
  private biddingStore = inject(BiddingStoreService);

  @Input() stepId = BiddingStoreKey.bidForData;

  bidFor$ = this.biddingStore.getSelector(BiddingStoreKey.bidForData);
  form: UntypedFormGroup | null = null;

  private isFormValid = false;

  onFormValidityChanged(isValid: boolean) {
    this.isFormValid = isValid;
  }

  onFormValuesChanged(data: BiddingModels.PlaceBidForFormModel | null): void {
    this.biddingStore.update({
      [BiddingStoreKey.bidForData]: deepClone(data),
    });
  }

  canEntry() {
    return true;
  }

  canExit() {
    return this.isFormValid;
  }
}
